import React, {useEffect, useRef, useState} from 'react';

import {useRecoilState} from "recoil";
import Config from "../core/config";
import Cookies from "js-cookie";
import {loadingAtom} from "../atoms";
import {useNavigate, useParams} from "react-router-dom";
import {customerKeyExists, getCompanyOfCurrentUser} from "../utils/requestUtils";
import { showConfirm, showAlert } from '../core/dialog';
import {isAuthenticated} from "../utils/auth";
import {getPreFillData} from "./cookieConsentUtils";
import facilitoyLogo from "../img/customer_auto_filling_facilitoy_logo.png";


const apiUrl = Config.apiUrl;
const currentUrl = window.location.href;
const CustomerAutoFilling_Name = (props, {onCustomerAdded}) => {
    const {customerKey} = useParams();
    const navigate = useNavigate();
    const [, setLoading] = useRecoilState(loadingAtom);
    const currentCustomerAutoFilling = Cookies.get('customerAutoFilling');
    const [customerKeyValid, setCustomerKeyValid] = useState(false);
    const [keyResponse, setKeyResponse] = useState(null);
    const [companyImg, setCompanyImg] = useState(Cookies.get('selfRegistrationImagePath') || null);
    const [notRegisteredYet, setNotRegisteredYet] = useState(false);
    const inputTextName = useRef();

    const newEntity = {
        id: undefined,
        customerKey: customerKey || '',
        name: '',
        address: '',
        addressComplement: '',
        neighborhood: '',
        cep: '',
        city: '',
        state: '',
        phone: '',
        email: '',
        instagram: '@',
        birthDate: undefined,
        rg: '',
        cpf: '',
        delivery: false,
        spaceBorneDelivery: false,
        howDidYouFindUs: '',
        referral: '',
        kids: []
    };

    const [formData, setFormData] = useState(currentCustomerAutoFilling ? JSON.parse(currentCustomerAutoFilling) : newEntity);

    const applyPreFill = () => {
        const preFill = getPreFillData();
        if (!preFill) return;
        setFormData(prev => {
            const merged = { ...prev };
            Object.keys(preFill).forEach(field => {
                const cur = merged[field];
                if (cur === undefined || cur === null || cur === '' || cur === '@') {
                    merged[field] = preFill[field];
                }
            });
            return merged;
        });
    };

    useEffect(() => {
        applyPreFill();
    }, []);

    const handleChange = (e) => {
        const {name, value, type, checked} = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    // Efeito 1: busca a resposta da API uma única vez quando a chave muda
    useEffect(() => {
        if (!customerKey) {
            setCustomerKeyValid(false);
            navigate(`/autocadastro/linkInvalido`);
            return;
        }
        customerKeyExists(customerKey).then(response => setKeyResponse(response));
    }, [customerKey, navigate]);

    // Efeito 2: decide a navegação depois que a resposta estiver pronta
    useEffect(() => {
        if (!keyResponse) return;

        const handleNavigation = async () => {
            setCustomerKeyValid(keyResponse.valid);

            if (keyResponse.valid) {
                Cookies.set('customerKey', customerKey);
                if (keyResponse.selfRegistrationImagePath) {
                    Cookies.set('selfRegistrationImagePath', keyResponse.selfRegistrationImagePath);
                    setCompanyImg(keyResponse.selfRegistrationImagePath);
                } else {
                    Cookies.remove('selfRegistrationImagePath');
                    setCompanyImg(null);
                }
                if (isAuthenticated() && keyResponse.customerCompanyId) {
                    const userCompany = await getCompanyOfCurrentUser();
                    if (userCompany && userCompany.id === keyResponse.customerCompanyId) {
                        setNotRegisteredYet(true);
                        return;
                    }
                }
                inputTextName.current?.focus();
            } else if (keyResponse.alreadyUsed && keyResponse.customerId && isAuthenticated()) {
                const userCompany = await getCompanyOfCurrentUser();
                const sameCompany = userCompany && userCompany.id === keyResponse.customerCompanyId;
                if (sameCompany) {
                    navigate(`/app/customer?id=${keyResponse.customerId}`);
                } else {
                    navigate(`/unauthorizedaccess`);
                }
            } else {
                navigate(`/autocadastro/cadastroRealizado`);
            }
        };

        handleNavigation();
    }, [keyResponse, customerKey, navigate]);

    function validateInputs() {

        if (!formData.name || formData.name === '') {
            if (inputTextName.current) {
                inputTextName.current.focus();
            }
            showAlert('Preencha o campo nome.');
            return false;
        }

        if (formData.name.split(' ').length < 2) {
            if (inputTextName.current) {
                inputTextName.current.focus();
            }
            showAlert('Informe o nome completo.');
            return false;
        }

        return true;
    }

    async function save() {
        Cookies.set('customerAutoFilling', JSON.stringify(formData));
        navigate(`/autocadastro/documentos`);
    }


    async function handleContinue() {
        if (validateInputs()) {
            await save();
        }
    }

    if (notRegisteredYet) {
        return (
            <div style={{textAlign: 'center', marginTop: '40px'}}>
                {companyImg && <div style={{marginBottom: '20px'}}><img src={companyImg} alt="Logo" style={{maxHeight: '120px', width: 'auto'}}/></div>}
                <p style={{marginTop: '20px', fontSize: '16px'}}>O cliente ainda não preencheu o cadastro.</p>
            </div>
        );
    }

    return (
        <div>
            {companyImg && <div style={{textAlign: 'center'}}><img src={companyImg} alt="Logo" style={{maxHeight: '120px', width: 'auto'}}/></div>}
            <div style={{marginTop: '10px', alignItems: 'center'}}>
                <div style={{width: '180px'}}>Nome completo:</div>
                <input ref={inputTextName} type="text" style={{width: '300px'}} value={formData.name} name="name"
                       onChange={handleChange}
                    //    onKeyUp={(e) => {
                    // if (e.key === 'Enter') {
                    //     handleContinue();
                    // }}}
                />
            </div>


            <div style={{marginTop: '10px', display: 'flex', justifyContent: 'flex-end', gap: '8px'}}>
                <button onClick={handleContinue}>Continuar</button>
            </div>

        </div>
    );
};

export default CustomerAutoFilling_Name; 